
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("lCHNh", function(module, exports) {
/* TeammateContentRecommendationBanner.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $hmuev = parcelRequire("hmuev");


var $1qfLF = parcelRequire("1qfLF");


var $gdv5Z = parcelRequire("gdv5Z");


var $1s5hv = parcelRequire("1s5hv");


var $iXCQx = parcelRequire("iXCQx");


var $1Whri = parcelRequire("1Whri");


var $cO1el = parcelRequire("cO1el");


var $gj7hi = parcelRequire("gj7hi");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $4PPzL = parcelRequire("4PPzL");


var $3IBnw = parcelRequire("3IBnw");

var $e54fd99e963652e1$exports = {};
$e54fd99e963652e1$exports = new URL("LightWelcomeImage.b703b601.png", import.meta.url).toString();


var $b17767b8b03c4d67$exports = {};
$b17767b8b03c4d67$exports = new URL("DarkWelcomeImage.ebbc9b04.png", import.meta.url).toString();


const $a582536f0b887dff$var$useContentRecommendationParam = (0, $dPJCf.createSingleQueryParamHook)('contentRecommendation');
const $a582536f0b887dff$var$usePopularParam = (0, $dPJCf.createSingleQueryParamHook)('popular');
const $a582536f0b887dff$var$unboundedStyles = {
    root: "_1reo15vq _18m915vq _18zroahv _x3doia51 _n7zlia51 _1bsb5xur _18u09b24 _bfhk1s93 _4t3i1j4a _kqswh2mm",
    headingStyles: "_1reo15vq _18m915vq _1bto1l2s _1e0ccj1k _1yyjkb7n _sudp1e54",
    subtextStyles: "_1reo15vq _18m915vq _1bto1l2s _1e0ccj1k _1yyjcs5v _sudp1e54",
    livePageStyle: "_x3doglyw _18u0ze3t _1bsb1wug"
};
const $a582536f0b887dff$var$styles = {
    contentContainerStyles: "_zulpu2gc _1yt41ejb _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _1bah1h6o _1pbykb7n _1bsb1nrf",
    svgContainer: "_1bsbhwvj _1e0c1txw _4cvr1h6o _1bah1h6o _lcxvglyw",
    closeButton: "_kqswstnw _154iutpp _1xi2utpp _lcxv1wug"
};
const $a582536f0b887dff$var$i18n = (0, $aXWIB.defineMessages)({
    bannerWelcomeMessage: {
        id: "experiment-teammate-content-screen-page.teammate-content-recommendation-banner.heading",
        defaultMessage: "Welcome to Confluence"
    },
    bannerWelcomeMessageWithName: {
        id: "experiment-teammate-content-screen-page.teammate-content-recommendation-banner.heading.with-name",
        defaultMessage: "Welcome to Confluence, {firstName}"
    },
    bannerDefaultSubtext: {
        id: "experiment-teammate-content-screen-page.teammate-content-recommendation-banner.no.teammates.subtext",
        defaultMessage: "This page was handpicked for you based on your role to help you dive into what\u2019s most relevant as you start in Confluence."
    },
    bannerTeammatesSubtext: {
        id: "experiment-teammate-content-screen-page.teammate-content-recommendation-banner.with.teammates.subtext",
        defaultMessage: "This page was handpicked for you based on your role and teammates to help you dive into what\u2019s most relevant as you start in Confluence."
    },
    bannerDismissLabel: {
        id: "experiment-teammate-content-screen-page.teammate-content-recommendation-banner.dismiss",
        defaultMessage: "Dismiss banner"
    },
    bannerPopularSubtext: {
        id: "experiment-teammate-content-screen-page.teammate-content-recommendation-banner.with.popular.subtext",
        defaultMessage: "We\u2019ve handpicked this page from your organization\u2019s most popular content so you can dive into what people find most useful."
    }
});
const $a582536f0b887dff$var$TeammateContentRecommendationBannerContent = ({ isLivePage: isLivePage })=>{
    const [isDismissed, setIsDismissed] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { displayName: displayName } = (0, $bQm3c.useSessionData)();
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const popularParam = $a582536f0b887dff$var$usePopularParam();
    const isPopularMessageVariant = popularParam === 'true';
    const firstName = displayName?.split(' ')[0] ?? null;
    (0, $42omo.useEffect)(()=>{
        if (!isDismissed) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'teammateContentRecommendationBanner'
            }
        }).fire();
    }, [
        isDismissed,
        createAnalyticsEvent
    ]);
    const handleDismiss = ()=>{
        setIsDismissed(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'dismissed',
                actionSubject: 'banner',
                actionSubjectId: 'teammateContentRecommendationBanner',
                source: 'viewPageContentContainer'
            }
        }).fire();
        setQueryParams({
            contentRecommendation: undefined
        });
    };
    if (isDismissed) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-vc": "teammate-content-recommendation-banner",
        className: (0, $gMc0m.default)([
            $a582536f0b887dff$var$unboundedStyles.root,
            isLivePage && $a582536f0b887dff$var$unboundedStyles.livePageStyle
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($a582536f0b887dff$var$styles.contentContainerStyles)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $a582536f0b887dff$var$unboundedStyles.headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "large"
    }, firstName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...$a582536f0b887dff$var$i18n.bannerWelcomeMessageWithName,
        values: {
            firstName: firstName
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $a582536f0b887dff$var$i18n.bannerWelcomeMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $a582536f0b887dff$var$unboundedStyles.subtextStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        as: "p"
    }, isPopularMessageVariant ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $a582536f0b887dff$var$i18n.bannerPopularSubtext) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $a582536f0b887dff$var$i18n.bannerTeammatesSubtext)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($a582536f0b887dff$var$styles.svgContainer)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($e54fd99e963652e1$exports))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($b17767b8b03c4d67$exports))),
        alt: ""
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($a582536f0b887dff$var$styles.closeButton)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        testId: "teammate-content-button-close",
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        label: $a582536f0b887dff$var$i18n.bannerDismissLabel.defaultMessage,
        onClick: handleDismiss
    })));
};
const $a582536f0b887dff$var$TeammateContentRecommendationBannerInner = ({ contentId: contentId, isLivePage: isLivePage })=>{
    const contentRecommendationParam = $a582536f0b887dff$var$useContentRecommendationParam();
    const isValidBannerRoute = (0, $dPJCf.useRouteName)({
        selector: (routeName)=>routeName === (0, $1NBp8.VIEW_PAGE).name || routeName === (0, $1NBp8.VIEW_BLOG).name || routeName === (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name
    });
    const shouldRenderBanner = isValidBannerRoute && !!contentId && contentRecommendationParam === 'on' && (0, $9wGTI.fg)('cc-engagement-nth-user-teammate-rollout-gate');
    if (!shouldRenderBanner) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a582536f0b887dff$var$TeammateContentRecommendationBannerContent, {
        isLivePage: isLivePage
    });
};
const $a582536f0b887dff$export$f9de7c50725ea941 = ({ contentId: contentId, isLivePage: isLivePage })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).FLYWHEEL_ENGAGEMENT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a582536f0b887dff$var$TeammateContentRecommendationBannerInner, {
        contentId: contentId,
        isLivePage: isLivePage
    }));
};
module.exports["TeammateContentRecommendationBanner"] = $a582536f0b887dff$export$f9de7c50725ea941;

});


//# sourceMappingURL=TeammateContentRecommendationBanner.f0d0a3a1.js.map
